module.exports = __webpack_public_path__ + "static/media/SC_UT_04.2156639e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clothes/shirt/SC_UT_04.png
// module id = 117
// module chunks = 0